export const DOCS = 'docs';
export const RESOURCES = 'resources';
export const COMMUNITY = 'community';
export const GETSTARTED = 'get started';
